import { StarfieldBackground } from '@enterpress/holomatrix'
import { Hero } from './components/Hero'
import { Mission } from './components/Mission'
import { Infrastructure } from './components/Infrastructure'
import { Crew } from './components/Crew'
import { Features } from './components/Features'
import { Architecture } from './components/Architecture'
import { Preview } from './components/Preview'
import { Waitlist } from './components/Waitlist'
import { Footer } from './components/Footer'
import { LCARSFrame } from './components/LCARSFrame'
import { LanguageSwitcher } from './components/LanguageSwitcher'
import { useScrollDepth } from './hooks/useScrollDepth'
import { TrackedSection } from './hooks/useSectionTracking.js'
import { TranslationProvider } from './i18n/index'

function App() {
  // Track scroll depth milestones (25%, 50%, 75%, 100%)
  useScrollDepth()

  return (
    <TranslationProvider>
      <div className="relative min-h-screen overflow-x-hidden">
        {/* Starfield background from holomatrix - renders behind everything */}
        <StarfieldBackground density={4} showNebula={true} showVignette={true} />
        
        <LanguageSwitcher />
        
        {/* LCARS Frame - decorative borders */}
        <LCARSFrame />
        
        {/* Main content - z-20 to be above starfield (z-0) and vignette (z-1) */}
        {/* Padding to avoid LCARS frame overlap: pl-[60px] pr-[60px] on large screens */}
        <main className="relative z-20 lg:pl-[70px] lg:pr-[70px]">
          <TrackedSection name="Hero" as="div">
            <Hero />
          </TrackedSection>
          <TrackedSection name="Mission" as="div">
            <Mission />
          </TrackedSection>
          <TrackedSection name="Infrastructure" as="div">
            <Infrastructure />
          </TrackedSection>
          <TrackedSection name="Crew" as="div">
            <Crew />
          </TrackedSection>
          <TrackedSection name="Features" as="div">
            <Features />
          </TrackedSection>
          <TrackedSection name="Architecture" as="div">
            <Architecture />
          </TrackedSection>
          <TrackedSection name="Preview" as="div">
            <Preview />
          </TrackedSection>
          <TrackedSection name="Waitlist" as="div">
            <Waitlist />
          </TrackedSection>
        </main>
        
        <Footer />
      </div>
    </TranslationProvider>
  )
}

export default App
